import {NgModule} from '@angular/core';
import {WorkHistoryModule} from './history/work.module';
import {MilitaryExperienceModule} from './military/military-experience.module';
import {WorkObservationsModule} from './observations/work-observations.module';
import {ActivityLogsModule} from './activity-logs/activity-logs.module';
import {WorkHistoryNotesModule} from './work-history-notes/work-history-notes.module';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [WorkHistoryModule, MilitaryExperienceModule, WorkObservationsModule, ActivityLogsModule, WorkHistoryNotesModule]
})
export class WorkModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/work.module.ts